<script lang="ts" setup>
import { defineProps } from 'vue'
const props = defineProps({
  fill: {
    type: String,
    default: 'black',
  },
  stroke: {
    type: String,
    default: 'black',
  },
})
</script>
<template>
  <svg
    width="100%"
    height="100%"
    viewBox="1 1 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66667 5.33333H8.33333V4.66667C8.33333 3.74667 7.58667 3 6.66667 3C5.74667 3 5 3.74667 5 4.66667V5.33333H4.66667C4.3 5.33333 4 5.63333 4 6V9.33333C4 9.7 4.3 10 4.66667 10H8.66667C9.03333 10 9.33333 9.7 9.33333 9.33333V6C9.33333 5.63333 9.03333 5.33333 8.66667 5.33333ZM5.66667 5.33333V4.66667C5.66667 4.11333 6.11333 3.66667 6.66667 3.66667C7.22 3.66667 7.66667 4.11333 7.66667 4.66667V5.33333H5.66667Z"
      :fill="props.fill"
    />
  </svg>
</template>
